import * as tslib_1 from "tslib";
import { OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { PitUsersService } from "../../../../pit-shared/services/pit-users.service";
import { PitResponsiblesService } from "../../../../pit-shared/services/pit-responsibles.service";
import { DxNciService } from "../../../../dx-nci-core/services/dx-nci.service";
import { DxModalService } from "../../../../dx-modals/services/dx-modal.service";
import { DxModalResultType } from "../../../../dx-modals/domain/dx-modal-result-type";
const LOADING_MESSAGE = 'Идёт загрузка данных';
export class PitResponsibleUsersComponent {
    constructor(usersService, responsiblesService, nciService, modalService) {
        this.usersService = usersService;
        this.responsiblesService = responsiblesService;
        this.nciService = nciService;
        this.modalService = modalService;
        this.formGroup = new FormGroup({});
        this.isInitialized = false;
        /** индикация загрузки. */
        this.isLoading = false;
        this.loadingMessage = '';
        this.trackById = (index, respUser) => respUser.id + '_' + respUser.responsibilityTypeId;
    }
    _showLoader(message) {
        if (message) {
            this.loadingMessage = message;
        }
        this.isLoading = true;
    }
    _hideLoader() {
        this.isLoading = false;
    }
    ngOnInit() {
        this.ngOnChanges();
    }
    ngOnChanges() {
        if (this.anObject.id && !this.isInitialized) {
            this.initAll().then();
        }
    }
    initAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isInitialized = true;
            this._showLoader(LOADING_MESSAGE);
            this.usersDict = yield this.usersService.getUsers().toPromise();
            this.responsibilityTypes = (yield this.nciService.fetchBackendDictionary('responsibility-type').toPromise()).elements;
            const allRespUsers = yield this.responsiblesService.getAll(this.anObject.id, this.anObjectTypeId).toPromise();
            if (allRespUsers) {
                this.responsibleUsers = allRespUsers.responsibleUsers;
                this.initControls();
            }
            this._hideLoader();
            return Promise.resolve();
        });
    }
    initControls() {
        this.responsibleUsers.forEach((respUser, index) => {
            let control = this.formGroup.controls['responsibleUserCombo' + respUser.id] = new FormControl(null, []);
            control.setValue(respUser.userId);
        });
    }
    getResponsibilityTypeName(typeId) {
        return this.responsibilityTypes.find(type => type.id === typeId).name;
    }
    onRecreateButton() {
        this.modalService.showConfirm('Вы уверенны, что хотите пересоздать ответственных?').subscribe(result => {
            if (result.type === DxModalResultType.OK) {
                this.onCreateButton();
            }
        });
    }
    onCreateButton() {
        this._showLoader(LOADING_MESSAGE);
        this.responsiblesService.create(this.anObject.id, this.anObjectTypeId).subscribe(allRespUsers => {
            this.responsibleUsers = allRespUsers.responsibleUsers;
            this.initControls();
            this._hideLoader();
        });
    }
    onValueChange(respUserId, userId) {
        const respUser = this.responsibleUsers.find(respUser => respUser.id === respUserId);
        // назначили ответственного
        respUser.userId = userId;
        this.responsiblesService.updateEntry(this.anObject.id, this.anObjectTypeId, respUser).subscribe();
    }
}
